module.exports = __webpack_public_path__ + "static/img/jcfx.177f529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jcfx.png
// module id = v9H+
// module chunks = 1